const selectLanguage = (state) => state.i18n.language || 'EN';

export default {selectLanguage};